import { getFeaturedProject } from '../../data/projects';
import SectionHeader from '../../components/ui/SectionHeader/SectionHeader';
import FeaturedProjectPreview from './FeaturedProjectPreview/FeaturedProjectPreview';
import './Projects.css';

export default function Projects() {
  const project = getFeaturedProject();

  return (
    <section id="projects" className="projects-section">
      <div className="projects-section__head">
        <SectionHeader
          eyebrow="Our Current Project"
          title="The current"
          titleEm="development"
        />
      </div>

      {project && <FeaturedProjectPreview project={project} />}
    </section>
  );
}
